import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import VideoModal from 'components/VideoModal'
import { useCourseBySlug } from 'libs/client/api'
import { useQRCTAHref } from 'pages/find-my-classes/hooks'
import { useVideoContext } from './useVideoContext'

export const TrailerModal = () => {
  const { isModalOpen, currentContent, closeVideo } = useVideoContext()
  const { courseBySlug: course } = useCourseBySlug(currentContent?.slug)

  // useQRCTAHref() will return undefined if the user is not on the quiz results page
  // and trailer modal will redirect to the value of the usePrimaryCta hook
  const ctaHref = useQRCTAHref()

  if (!course) {
    return null
  }

  return (
    <VideoModal
      show={isModalOpen}
      onCloseModal={closeVideo}
      videoId={course.brightcoveVideoId}
      mediaUuid={course.mediaUuid}
      trackProps={{ uuid: course.uuid }}
      author={course.instructorName}
      tagline={course.skill}
      contentId={`${course.id}_${course.brightcoveVideoId ?? course.mediaUuid}`}
      contentTitle={course.title}
      contentType={TRACK_CONTENT_TYPES.COURSE_TRAILER}
      courseId={course.id}
      instructorAvatar={course.primary1x1}
      signUpHref={ctaHref}
    />
  )
}
